import { CSSProperties } from "react";
import SelectComponent from "src/shared-elements/select/select-component";
import TabularSelectComponent from "src/shared-elements/tabular-select/tabular-select";

interface TabularFilterProps {
  selectedValue: string | null;
  options: any[];
  onChangeHandler: (value: string) => void;
  placeHolder?: string;
  style?: CSSProperties;
}

const TabularFilterComponent: React.FC<TabularFilterProps> = ({
  selectedValue,
  options,
  onChangeHandler,
  placeHolder,
  style,
}) => {
  const containerStyle: CSSProperties = {
    display: "flex",
    position: "relative",
  };

  const selectStyle: CSSProperties = {
    width: "20%",
    position: "absolute",
    zIndex: "999",
    top: "-50px",
    right: "0",
  };

  return (
    <div className="w-100" style={containerStyle}>
      <div style={style || selectStyle}>
        <TabularSelectComponent
          selectedValue={selectedValue}
          options={options}
          placeHolder={placeHolder}
          onChange={onChangeHandler}
        />
      </div>
    </div>
  );
};

export default TabularFilterComponent;
